import React, { ReactNode, useEffect, useState } from "react";
import cx from "classnames";
import { AppHeaderUser } from "./AppHeaderUser";
import { AppHeaderLinks } from "./AppHeaderLinks";
import { AnimatePresence as FramerAnimatePresence, motion } from "framer-motion";
// import cadtitle from "img/cadence.svg";
import "./Header.css";
import { Link, useLocation } from "react-router-dom";
import classes from "./Header.module.scss";
import { Wrapper } from "../Wrapper/Wrapper";
import LongLogo from "../../img/cad_title_long.png";
import { headerLinks } from "../../config/links";
import { uniqueId } from "lodash";
import { UseBreakpoints } from "../../hooks/useBreakpoints";
import Burger from "./images/burgerButton.svg";
import { useWeb3React } from "@web3-react/core";
import { ReactComponent as SettingsIcon } from "./images/settingsIcon.svg";

// Fix framer-motion old React FC type (solved in react 18)
const AnimatePresence = (props: React.ComponentProps<typeof FramerAnimatePresence> & { children: ReactNode }) => (
  <FramerAnimatePresence {...props} />
);

const fadeVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

const slideVariants = {
  hidden: { x: "-100%" },
  visible: { x: 0 },
};

type Props = {
  disconnectAccountAndCloseSettings: () => void;
  openSettings: () => void;
  setWalletModalVisible: (visible: boolean) => void;
  redirectPopupTimestamp: number;
  showRedirectModal: (to: string) => void;
};

export function Header({
  disconnectAccountAndCloseSettings,
  openSettings,
  setWalletModalVisible,
  redirectPopupTimestamp,
  showRedirectModal,
}: Props) {
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [isNativeSelectorModalVisible, setIsNativeSelectorModalVisible] = useState(false);
  const { pathname } = useLocation();
  const { isMobile } = UseBreakpoints();
  const { active } = useWeb3React();

  useEffect(() => {
    if (isDrawerVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isDrawerVisible]);

  return (
    <>
      {isDrawerVisible && (
        <AnimatePresence>
          {isDrawerVisible && (
            <motion.div
              className="App-header-backdrop"
              initial="hidden"
              animate="visible"
              exit="hidden"
              variants={fadeVariants}
              transition={{ duration: 0.2 }}
              onClick={() => setIsDrawerVisible(!isDrawerVisible)}
            ></motion.div>
          )}
        </AnimatePresence>
      )}
      {isNativeSelectorModalVisible && (
        <AnimatePresence>
          {isNativeSelectorModalVisible && (
            <motion.div
              className="selector-backdrop"
              initial="hidden"
              animate="visible"
              exit="hidden"
              variants={fadeVariants}
              transition={{ duration: 0.2 }}
              onClick={() => setIsNativeSelectorModalVisible(!isNativeSelectorModalVisible)}
            ></motion.div>
          )}
        </AnimatePresence>
      )}
      <header>
        <div className={classes.root}>
          <Wrapper className={classes.component}>
            <div className={classes.logoWrapper}>
              {isMobile && (
                <div className={classes.menuButton} onClick={() => setIsDrawerVisible(!isDrawerVisible)}>
                  {!isDrawerVisible && (
                    <div className={classes.button}>
                      <img src={Burger} alt="" />
                    </div>
                  )}
                </div>
              )}
              <Link to={"/"}>
                <img src={LongLogo} width={200} height={48} alt="" className="" />
              </Link>
            </div>
            <div className={classes.linksWrapper}>
              {headerLinks.map((link) => (
                <Link
                  className={cx(classes.link, pathname === link.ulr ? classes.linkActive : "")}
                  key={uniqueId(link.title)}
                  to={link.ulr}
                >
                  {link.title}
                </Link>
              ))}
            </div>
            {!isMobile ? (
              <div className={classes.connectMenuWrapper}>
                <AppHeaderUser
                  disconnectAccountAndCloseSettings={disconnectAccountAndCloseSettings}
                  setWalletModalVisible={setWalletModalVisible}
                />
                {active && (
                  <div className={classes.settingsButton} onClick={openSettings}>
                    <SettingsIcon />
                  </div>
                )}
              </div>
            ) : (
              <></>
            )}
          </Wrapper>
        </div>
      </header>
      {/*mobile menu*/}
      <AnimatePresence>
        {isDrawerVisible && (
          <motion.div
            className={classes.mobileMenu}
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={slideVariants}
            transition={{ duration: 0.3 }}
          >
            <AppHeaderLinks
              small
              openSettings={openSettings}
              clickCloseIcon={() => setIsDrawerVisible(false)}
              redirectPopupTimestamp={redirectPopupTimestamp}
              showRedirectModal={showRedirectModal}
              disconnectAccountAndCloseSettings={disconnectAccountAndCloseSettings}
              setWalletModalVisible={setWalletModalVisible}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
